import { combineReducers } from 'redux-immutable';
import techTracking from 'src/containers/Account/OrderPage/Parts/Tech/TechLocation/TechTrackingWS/reducer';

export default () =>
  combineReducers({
    locations: techTracking,
  });
